import axios from "axios"
import Swal from "sweetalert2";
import api from "../../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY


export const getProveedores = async () => {
    try {
        const result = await api.get(`${urlApi}/administracion/partnerPayment/getPartners`);
        return result.data;
    } catch (e) {
        throw new Error(e);
    }
}

export const getSubirExel = async (archivo, idProveedor) => {
    try {
        const formData = new FormData();
        formData.append('file', archivo);
        const result = await api.post(`${urlApi}/administracion/partnerPayment/getDataTables?proveedor=${idProveedor}`, formData);
        return result.data;
    } catch (error) {
        throw new Error(error);
    }
}


export const subirAoddo = async (id_proveedor, fecha_inicio, fecha_fin, serDataTableExel, serDataTableSuma) => {
    try {
        const response = await api.post(`${urlApi}/administracion/partnerPayment/sendToPay?proveedor=${id_proveedor}&fecha_inicio=${fecha_inicio}&fecha_fin=${fecha_fin}`);
        return response.data;

    } catch (error) {
        throw new Error(error);
    }
}